module.exports = __webpack_public_path__ + "static/media/poc-user-type-inactive.971828f9.svg";